var SidebarNavView = require('common/views/SidebarNavView');
var tmplCOCInternalSidebarNavView = require('../templates/COCInternalSidebarNavView.hbs');

module.exports = SidebarNavView.extend({
  template: tmplCOCInternalSidebarNavView
});
